'use client';

import { APP_ROUTES } from '@/routes';
import type { ResetPasswordFormType } from '../schemas';
import { useFirebaseAuthMutations } from './mutations';
import { useRouter } from 'next/navigation';
import { useToast } from '@packages/chakra-v3';

const useResetPassword = () => {
	const router = useRouter();
	const { resetPasswordMutation } = useFirebaseAuthMutations();
	const { showSuccess, showError } = useToast();

	const handleResetPasswordSuccess = () => {
		router.replace(APP_ROUTES.HOME);
		showSuccess({
			title:       'Password reset successfully',
			description: 'You can now login with your new password',
		});
	};

	const handleResetPasswordError = () => {
		showError({
			title:       'Password reset failed',
			description: 'Please try again',
		});
	};

	const handleResetPassword  = async({ password }: ResetPasswordFormType) => {
		const oobCode = new URLSearchParams(window.location.search).get('oobCode') || '';
		await resetPasswordMutation.mutateAsync({
			oobCode,
			password,
		}, {
			onSuccess: handleResetPasswordSuccess,
			onError:   handleResetPasswordError,
		});
	};

	return { handleResetPassword };
};

export default useResetPassword;